// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1200px) {
  .section-photo {
    background-color: #e31837;
    padding: 12px 16px !important;
  }
}

@media (min-width: 900px) {
  .section-photo {
    background-color: #e31837;
    padding: 12px 16px !important;
  }
}

.mobphotobg {
  background-color: #e31837;
}
.mobleadercontent {
  margin-top: 70px;
  margin-left: -130px;
}

.msg {
  display: flex !important;
}
.quote-img {
  margin-top: -10px;
  margin-right: 4px;
}
.mobleadercontent h4 {
  margin-bottom: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/sections/MessageItem.css"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":["@media (min-width: 1200px) {\n  .section-photo {\n    background-color: #e31837;\n    padding: 12px 16px !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .section-photo {\n    background-color: #e31837;\n    padding: 12px 16px !important;\n  }\n}\n\n.mobphotobg {\n  background-color: #e31837;\n}\n.mobleadercontent {\n  margin-top: 70px;\n  margin-left: -130px;\n}\n\n.msg {\n  display: flex !important;\n}\n.quote-img {\n  margin-top: -10px;\n  margin-right: 4px;\n}\n.mobleadercontent h4 {\n  margin-bottom: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
